var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("VuePlyr", { staticClass: "w-56 h-32", attrs: { autoplay: "" } }, [
    _c("div", { staticClass: "plyr__video-embed" }, [
      _c("iframe", {
        attrs: {
          src: _vm.demoReel,
          allowfullscreen: "",
          allow: "autoplay",
          autoplay: "",
          width: "224px",
          height: "128px",
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }